import axios from 'axios'
// const rooturl = process.env.BASE_API
// console.log(rooturl, 'rooturl')
// 开发
// const rooturl = 'http://10.0.0.115:9091'
// 测试
// const rooturl = 'http://10.0.0.125:8035'
let $axios = axios.create({
    // baseURL: rooturl,
    timeout: 5000 // 请求超时时间
  })

// $axios.interceptors.response.use(function (response) {
//     // 对响应数据做点什么
//     window.$judge = true
//     return response;
//   }, function (error) {
//     // 对响应错误做点什么
//     return Promise.reject(error);
//   });

// 部门
function getDepartment(){
    return $axios.request({
        method: 'post',
        url: '/apiOA/Department/GetAllDepartmentTreeViewInfo',
        data: ''
    })
}
// 科室医生
 function  getDoctor(){
     
    return  $axios.request({
        method: 'post',
        url: '/apiOA/Doctor/GetAllDoctorInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": "",
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
//根据医生ID 获取医生信息 
 function getDoctorDetail(urlid){
    return $axios.request({
        method: 'post',
        url: '/apiOA/Doctor/GetDoctorInfoByID',
        data: {
            "Head": {
              "Version": "",
              "Language": "",
              "HospitalCode": "",
              "AppType": 0
            },
            "Content": {
              "Key": urlid,
              "Keys": {},
              "CurrentPage": 0,
              "PageSize": 0,
              "TotalCount": 0
            }
          }
    })
 }

 //获取 专家页面 tree
 function getDocTree(lang){
    return  $axios.request({
        method: 'post',
        url: '/apiOA/DoctorDepartment/GetAllDepartmentDoctorInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
              },
              "Content": {
                "Key": '',
                "Keys": {
                    LanguageCode: lang
                },
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
              }
        }
    })
 }
  //获取 一级科室 or 二级科室 or 医生 获取 head 一级科室
function getDoc(lang){
    return  $axios.request({
        method: 'post',
        url: '/apiOA/DoctorDepartment/GetAllDoctorDepartmentInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
              },
              "Content": {
                "Key": '0',
                "Keys": {
                    'LanguageCode': lang
                },
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
              }
        }
    })
 }

 //获取二级科室详情
 function getDepartmentDetail (urlid){
     return $axios.request({
         method: 'post',
         url: '/apiOA/DoctorDepartment/GetDoctorDepartmentInfoByID',
         data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": urlid,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
         }
     })
 }
 //获取一级科室详情
 function getFirstDepartmentDetail (urlid){
    return $axios.request({
        method: 'post',
        url: '/apiOA/DoctorDepartment/GetDoctorDepartmentInfoByID',
        data: {
           "Head": {
               "Version": "",
               "Language": "",
               "HospitalCode": "",
               "AppType": 0
           },
           "Content": {
               "Key": "1",
               "Keys": {"ParentID":urlid},
               "CurrentPage": 0,
               "PageSize": 0,
               "TotalCount": 0
           }
        }
    })
}

//获取 医院动态全部类型 分层级tree 
function getHosDynamic (TypeID, lang){
    return $axios.request({
        method: 'post',
        url: '/apiOA/Article/GetArticleInfoByType',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "TypeID": [
                    TypeID
                ],
                "LanguageCode": lang,
                "ReviewStatus": 2
            }  
        }
    })
}

// 根据类型 获取文章 一次九条  招标公告列表页
function getArticle (urlid,CurrentPage) {
    console.log(urlid, CurrentPage, 'sfds')
    return $axios.request({
        method: 'post',
        url: '/apiOA/Article/GetArticleInfoByTitleAndType',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": "",
                "Keys": {"TypeID":urlid,"ReviewStatus": 2},
                "CurrentPage": CurrentPage,
                "PageSize": 9,
                "TotalCount": 0
            }   
        }
    })
}

//获取文章详情

function getArticleDetail (urlid) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/Article/GetArticleInfoByID',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": urlid,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }  
        }
    })
}

//获取 所有的文章 取前8条 (审核通过的文章)
function getAllArticle (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/Article/GetAllArticleInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {'ReviewStatusID': 2},
                "CurrentPage": 0,
                "PageSize": 10,
                "TotalCount": 0
            } 
        }
    })
}

//获取轮播图
function getCarousel(lang){
    return $axios.request({
        method: 'post',
        url: '/apiOA/CarouselPicture/GetCarouselPictureInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            } 
        }
    })
}
// 获取医院简介
function getHosIntro (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/HospitalIntroduction/GetHospitalIntroduction',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            } 
        }
    })
}
// 获取医院荣誉
function getHosHonor (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/HonorInfo/GetHonorInfo',
        data: {  
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang
            } 
        }
    })
}
// 获取职位信息(可根据id)
function getJobDetail (urlid) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/RecruitmentPosition/GetRecruitmentPositionInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": '',
                "Keys": {
                    ID: urlid
                },
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
// 获取职位(可根据id)
function getJob (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/RecruitmentPosition/GetRecruitmentPositionInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": '',
                "Keys": {
                    LanguageCode: lang
                },
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
// 获取职位 banner图
function getJoinUsBanner (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/RecruitmentPosition/GetRecruitmentPositionTopImageInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
// 获取预约信息
function getAppointmentInfo (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/AppointmentRegistration/GetAppointmentRegistration',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
// 获取来院导航信息
function getHosnav (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/MapNavigation/GetMapNavigationInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
// 获取底部友链
function getFriend (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/WebFootLink/GetWebFootLinkInfo',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {},
                "CurrentPage": 0,
                "PageSize": 0,
                "TotalCount": 0
            }
        }
    })
}
// 获取联系方式
function getContact (lang) {
    return $axios.request({
        method: 'post',
        url: '/apiOA/ContactInformation/GetContactInformation',
        data: {
            "Head": {
                "Version": "",
                "Language": "",
                "HospitalCode": "",
                "AppType": 0
            },
            "Content": {
                "Key": lang,
                "Keys": {}
            }
        }
    })
}
export  {
    getDoctor,
    getDepartment,
    getDoctorDetail,
    getDoc,
    getDocTree,
    getDepartmentDetail,
    getFirstDepartmentDetail,
    getHosDynamic,
    getArticle,
    getArticleDetail,
    getAllArticle,
    getCarousel,
    getHosIntro,
    getHosHonor,
    getJob,
    getJobDetail,
    getAppointmentInfo,
    getHosnav,
    getFriend,
    getContact,
    getJoinUsBanner
} 




// WEBPACK FOOTER //
// ./src/api/api.js